import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const GET_GLOBAL_TOKEN_SETTINGS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getGlobalTokenSettings',
    operationName: 'getGlobalTokenSettings',
    fields: '{...TokenSettingsResponseFields}',
    fragments: [Fragments.tokenSettingsResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_PROJECT_TOKEN_SETTINGS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getProjectTokenSettings',
    operationName: 'getProjectTokenSettings',
    args: [
      { name: 'project_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'project_id', value: 'project_id' },
    ],
    fields: '{...TokenSettingsResponseFields}',
    fragments: [Fragments.tokenSettingsResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
